var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStaticRoute(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 9.5C10.1716 9.5 9.5 10.1716 9.5 11C9.5 11.8284 10.1716 12.5 11 12.5C11.8284 12.5 12.5 11.8284 12.5 11C12.5 10.1716 11.8284 9.5 11 9.5ZM6.5 11C6.5 8.51472 8.51472 6.5 11 6.5C12.9593 6.5 14.6262 7.75221 15.2439 9.5H26C29.3137 9.5 32 12.1863 32 15.5C32 18.8137 29.3137 21.5 26 21.5H14C12.3431 21.5 11 22.8431 11 24.5C11 26.1569 12.3431 27.5 14 27.5H24.7561C25.3738 25.7522 27.0407 24.5 29 24.5C31.4853 24.5 33.5 26.5147 33.5 29C33.5 31.4853 31.4853 33.5 29 33.5C27.0407 33.5 25.3738 32.2478 24.7561 30.5H14C10.6863 30.5 8 27.8137 8 24.5C8 21.1863 10.6863 18.5 14 18.5H26C27.6569 18.5 29 17.1569 29 15.5C29 13.8431 27.6569 12.5 26 12.5H15.2439C14.6262 14.2478 12.9593 15.5 11 15.5C8.51472 15.5 6.5 13.4853 6.5 11ZM29 27.5C28.1716 27.5 27.5 28.1716 27.5 29C27.5 29.8284 28.1716 30.5 29 30.5C29.8284 30.5 30.5 29.8284 30.5 29C30.5 28.1716 29.8284 27.5 29 27.5Z",
    fill: "#131313",
    fillOpacity: 0.63
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStaticRoute);
export default __webpack_public_path__ + "static/media/static_route.841c45a41619dbbae65054046982dded.svg";
export { ForwardRef as ReactComponent };